import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);
const routes = [
  //配置路由，这里是个数组
  {
    //每一个链接都是一个对象
    path: "/", //链接路径
    name: "Index", //路由名称，
    meta: { power: 0 }, // power:0->不需要登录即可访问 1->需要登录才可以访问 2->登录后不可以访问
    component: () => import("../page/index")
  },
  {
    path: "/goodsDetail",
    name: "goodsDetail",
    meta: { power: 0 },
    component: () => import("../page/goodsDetail")
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../page/login"),
    meta: { power: 2 }
  },
  {
    path: "/forgot",
    name: "RorGot",
    component: () => import("../page/forgot"),
    meta: { power: 2 }
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../page/register"),
    meta: { power: 2 }
  },
  {
    path: "/password",
    name: "password",
    component: () => import("../page/password"),
    meta: { power: 2 }
  },
  {
    path: "/shoppingCar",
    name: "ShoppingCar",
    component: () => import("../page/shoppingCar"),
    meta: { power: 1 }
  },
  {
    path: "/purchaseAssistant",
    name: "purchaseAssistant",
    component: () => import("../page/purchaseAssistant"),
    meta: { power: 0 }
  },
  {
    path: "/storageService",
    name: "storageService",
    component: () => import("../page/storageService"),
    meta: { power: 0 }
  },
  {
    path: "/caseService",
    name: "caseService",
    component: () => import("../page/caseService"),
    meta: { power: 0 }
  },
  {
    path: "/userRegister",
    name: "userRegister",
    component: () => import("../page/userRegister"),
    meta: { power: 0 }
  },
  {
    path: "/goodsType",
    name: "goodsType",
    component: () => import("../page/goodsType"),
    meta: { power: 0 }
  },
  {
    path: "/recommend",
    name: "recommend",
    component: () => import("../page/recommend"),
    meta: { power: 0 }
  },
  {
    path: "/qanda",
    name: "qanda",
    component: () => import("../page/qanda"),
    meta: { power: 1 }
  },
  {
    path: "/newsList",
    name: "newsList",
    component: () => import("../page/newsList"),
    meta: { power: 0 }
  },
  {
    path: "/businessZone",
    name: "businessZone",
    component: () => import("../page/businessZone"),
    meta: { power: 0 }
  },
  {
    path: "/goodsFind",
    name: "goodsFind",
    component: () => import("../page/goodsFind"),
    meta: { power: 0 }
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: () => import("../page/newsDetail"),
    meta: { power: 0 }
  },
  {
    path: "/qaDetail",
    name: "qaDetail",
    component: () => import("../page/qaDetail"),
    meta: { power: 1 }
  },
  {
    path: "/orderInfo",
    name: "orderInfo",
    component: () => import("../page/orderInfo"),
    meta: { power: 1 }
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    component: () => import("../page/orderDetail"),
    meta: { power: 1 }
  },
  {
    path: "/goodsDetailZone",
    name: "goodsDetailZone",
    component: () => import("../page/goodsDetailZone"),
    meta: { power: 0 }
  },
  {
    path: "/pay",
    name: "pay",
    component: () => import("../page/pay"),
    meta: { power: 1 }
  },
  {
    path: "/payEnd",
    name: "payEnd",
    component: () => import("../page/payEnd"),
    meta: { power: 1 }
  },
  {
    path: "/vipCenter",
    name: "vipCenter",
    component: () => import("../page/vipCenter"),
    meta: { power: 1 }
  },
  {
    path: "/personinfo",
    name: "personinfo",
    component: () => import("../page/personinfo"),
    meta: { power: 1 }
  },
  {
    path: "/updatePassword",
    name: "updatePassword",
    component: () => import("../page/updatePassword"),
    meta: { power: 1 }
  },
  {
    path: "/purchaseApply",
    name: "purchaseApply",
    component: () => import("../page/purchaseApply"),
    meta: { power: 0 }
  },
  {
    path: "/purchaseList",
    name: "purchaseList",
    component: () => import("../page/purchaseList"),
    meta: { power: 0 }
  },
  {
    path: "/sellList",
    name: "sellList",
    component: () => import("../page/sellList"),
    meta: { power: 0 }
  },
  {
    path: "/sellApply",
    name: "sellApply",
    component: () => import("../page/sellApply"),
    meta: { power: 0 }
  },
  {
    path: "/setAddress",
    name: "setAddress",
    component: () => import("../page/setAddress"),
    meta: { power: 0 }
  },
  {
    path: "/message",
    name: "message",
    component: () => import("../page/message"),
    meta: { power: 0 }
  },
  {
    path: "/myOrder",
    name: "myOrder",
    component: () => import("../page/myOrder"),
    meta: { power: 1 }
  },
  {
    path: "/invoiceData",
    name: "invoiceData",
    component: () => import("../page/invoiceData"),
    meta: { power: 0 }
  },
  {
    path: "/invoiceInfo",
    name: "invoiceInfo",
    component: () => import("../page/invoiceInfo"),
    meta: { power: 1 }
  },
  {
    path: "/myCoupon",
    name: "myCoupon",
    component: () => import("../page/myCoupon"),
    meta: { power: 0 }
  },
  {
    path: "/consult",
    name: "consult",
    component: () => import("../page/consult"),
    meta: { power: 0 }
  },
  {
    path: "/complaint",
    name: "complaint",
    component: () => import("../page/complaint"),
    meta: { power: 0 }
  },
  {
    path: "/storeEntry",
    name: "storeEntry",
    component: () => import("../page/storeEntry"),
    meta: { power: 0 }
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../page/404"),
    meta: { power: 0 }
  }
];

const router = new VueRouter({
  //   mode: 'history',
  base: process.env.BASE_URL,
  routes
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

//登录权限验证
router.beforeEach((to, form, next) => {
  const { phone, from, pwd } = to.query;
  let { power } = to.meta;
  let { token } = store.getters;
  if (to.name == "login") {
    if (token) {
      next();
    } else {
      next("/login");
    }
  }
  if (power === 1) {
    if (token) {
      next();
    } else {
      next("/login");
    }
  } else if (power === 2) {
    if (!token) {
      next();
    } else {
      next("/");
    }
  } else {
    //从商家后台跳转到首尾荟
    if (from === "adminshop" && phone) {
      localStorage.setItem("digitalEmergenceName", true);
      let userToken = localStorage.getItem("loginToken");
      if (userToken) {
        next("/");
      } else {
        let password = pwd;
        store
          .dispatch("user/LoginTwin", { phone, password })
          .then(res => {
            if (res.access_token) {
              localStorage.setItem("name", phone);
              localStorage.setItem("pwd", password);
              store.dispatch("user/GetInfo").finally(res => {
                next("/");
              });
            } else {
              next("/");
            }
          })
          .catch(() => {
            next("/");
          });
      }
    }
    //从数字孚生 跳转过来 首尾荟商家后台    商家没有入驻就停留在首尾荟客户端
    if (from === "swhshop" && phone) {
      let password = "";
      password = pwd;
      let username = "";
      username = phone;
      store
        .dispatch("user/UserStore", { username, password })
        .then(res => {
          if (res.code === 200) {
            localStorage.setItem("name", phone);
            localStorage.setItem("pwd", password);
            const name = JSON.parse(localStorage.getItem("name"));
            const pwd = localStorage.getItem("pwd");
            const u = "http://shop.shouweihui.com/#/jumpTo";
            window.open(`${u}?username=${name}&password=${pwd}`);
          } else {
            store
              .dispatch("user/LoginTwin", { phone, password })
              .then(res => {
                if (res.access_token) {
                  localStorage.setItem("name", phone);
                  localStorage.setItem("pwd", password);
                  store.dispatch("user/GetInfo").finally(res => {
                    next("/");
                  });
                } else {
                  next("/");
                }
              })
              .catch(() => {
                next("/");
              });
          }
        })
        .catch(() => {
          next("/");
        });
    }
    //从数字孚生 跳转过来 首尾荟客户端
    if (from === "swh" && phone) {
      localStorage.setItem("digitalEmergenceName", true);
      let password = "";
      password = pwd;
      store
        .dispatch("user/LoginTwin", { phone, password })
        .then(res => {
          if (res.access_token) {
            localStorage.setItem("name", phone);
            localStorage.setItem("pwd", pwd);
            store.dispatch("user/GetInfo").finally(res => {
              next("/");
            });
          } else {
            next("/");
          }
        })
        .catch(() => {
          next("/");
        });
    } else {
      next();
    }
    // 如果是从智慧园区PC端跳转过来
    if (from === "smartpark" && phone) {
      store
        .dispatch("user/LoginPark", { phone })
        .then(res => {
          if (res.access_token) {
            store.dispatch("user/GetInfo").finally(res => {
              next("/");
            });
          } else {
            next("/");
          }
        })
        .catch(() => {
          next("/");
        });
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js